module.exports = __webpack_public_path__ + "jm.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/jm.svg
// module id = 881
// module chunks = 0